import { Box, TableCell, TableCellProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface Props extends TableCellProps {
  children: React.ReactNode;
  rowIsHovered?: boolean;
}
const StickyTableCell = ({ children, rowIsHovered, ...props }: Props) => {
  const theme = useTheme();
  return (
    <TableCell
      {...props}
      sx={{
        position: "sticky",
        left: 0,
        zIndex: 5,
        bgcolor: "white",
        height: 102,
        minHeight: 102,
        p: "0 !important",
        ...props.sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flexGrow: 1,
          height: 1,
          padding: 2,
          bgcolor: rowIsHovered ? "action.hover" : "inherit",
          transition: theme.transitions.create(["background-color"], {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        {children}
      </Box>
    </TableCell>
  );
};

export default StickyTableCell;
